
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    TextField,
    Autocomplete
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {LayoutFieldModel} from '../../models/models';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';

export const MultiSelectFieldComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: string[],
  onChange: (value: string[], layoutField: LayoutFieldModel) => void,
}> = ( {
  layoutField,
  value,
  onChange
}) => {

  //NOTE: value is always the array of keys

  const handleChange = (values: string[]) => {
    onChange(values, layoutField);
  }

  const required = checkLayoutFieldRequirement(layoutField);

  const error = () => {
    if(required &&
       (!value || value.length == 0)){
         return true
       }
    return false
  };

  //keys and selected values
  const keys = Object.keys(layoutField.ReferencedField_sys.PicklistValues_sys)

  return (
    <Autocomplete
      multiple
      disabled={layoutField.AccessSetting_sys === 'read'}
      options={keys}
      value={value}
      size='small'
      onChange={(_, newValue) => handleChange(newValue)}
      getOptionLabel={(key) => {
        return layoutField.ReferencedField_sys.PicklistValues_sys[key]
      }}
      renderInput={(params) => (
        <TextField
          required={required}
          variant="filled"
          label={`${layoutField.ReferencedField_sys.Label_sys} (max. ${layoutField.ReferencedField_sys.Length_sys})`}
          error={error()}
          helperText={layoutField.ReferencedField_sys.HelpText_sys}
          {...params}
        />
      )}
    />

  )
};
